const ERROR_CANNOT_OPERATE_BETWEEN_DIFFERENT_COUNTRIES = 'Cannot operate between different countries';

export {
  // eslint-disable-next-line import/prefer-default-export
  ERROR_CANNOT_OPERATE_BETWEEN_DIFFERENT_COUNTRIES,
};
